import { render, staticRenderFns } from "./ChangePasswordPage.vue?vue&type=template&id=caabd274&scoped=true"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=js"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=js"
import style0 from "./ChangePasswordPage.vue?vue&type=style&index=0&id=caabd274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caabd274",
  null
  
)

export default component.exports